export const lightMapStyle = "mapbox://styles/mpilarczykstarcount/cm0tlbxd100p801qudsi79pj0"
export const darkMapStyle = "mapbox://styles/mpilarczykstarcount/clzl1q9lh002u01pd8s03dapo"
